import { ChevronDown, ChevronUp } from "lucide-react";
import { cn } from "@/lib/utils";
import type { SortDirection } from "@/types/table-column";

interface SortIconProps {
  isActive: boolean;
  direction: SortDirection;
  showOnHover?: boolean;
  className?: string;
}

export function SortIcon({
  isActive,
  direction,
  showOnHover = true,
  className,
}: SortIconProps) {
  if (!isActive) {
    // Show a more subtle icon when not active but on hover
    return showOnHover ? (
      <ChevronDown
        className={cn(
          "h-4 w-4 opacity-0 group-hover:opacity-40 transition-opacity scale-x-75",
          className,
        )}
        strokeWidth={2.5}
      />
    ) : null;
  }

  // When active, show a more prominent icon
  if (direction === "asc") {
    return (
      <ChevronUp
        className={cn(
          "h-4 w-4 text-primary transition-all scale-x-75",
          className,
        )}
        strokeWidth={2.5}
      />
    );
  }

  return (
    <ChevronDown
      className={cn(
        "h-4 w-4 text-primary transition-all scale-x-75",
        className,
      )}
      strokeWidth={2.5}
    />
  );
}
